module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 4